module.exports = __webpack_public_path__ + "img/lx.3603d0e4.png";